<template>
  <div class="fixed-grid has-12-cols"
    :class="{ 'quote-comms-licence-expired': $licenceExpired }">
    <div v-if="value && customer && vehicle"
      class="grid is-col-min-15">
      <div class="cell is-flex pr-0"
        :class="{'is-col-span-12': editMaximize, 'is-col-span-6': isEmail && !editMaximize, 'is-col-span-7': !isEmail && !editMaximize }">
        <div class="is-flex-grow-1 is-flex">
          <article class="box detail-page-tile is-flex-grow-1 is-flex is-flex-direction-column">
            <p class="title">Message</p>

            <div class="tabs">
              <ul style="margin-top: 12px;">
                <li :class="{'is-active' : activeTab == 'SMS', 'tab-disabled': activeTab !== 'SMS' && (editMaximize)}"
                  @click="setActiveTab('SMS')">
                  <a>
                    <span>
                      <span class="has-badge-child-offset3">
                        <span class="icon">
                          <i class="mdi mdi-message-text mdi-20px"
                            aria-hidden="true" />
                        </span>
                        <span class="">SMS</span>
                      </span>
                      <span v-show="smsTotalCount"
                        class="has-badge-info has-badge-rounded has-badge-medium"
                        :class="{ 'has-new-content': smsUnreadCount > 0 }"
                        :data-badge="smsTotalCount" />
                    </span>

                  </a>
                </li>
                <li v-if="isShowWhatsApp"
                  :class="{'is-active' : activeTab == 'WhatsApp', 'tab-disabled': activeTab !== 'WhatsApp' && (editMaximize)}"
                  @click="setActiveTab('WhatsApp')">
                  <a>
                    <span>
                      <span class="has-badge-child-offset3">
                        <span class="icon">
                          <i class="mdi mdi-whatsapp mdi-20px icon-green" />
                        </span>
                        <span class="">WhatsApp</span>
                      </span>
                      <span v-show="whatsAppTotalCount"
                        class="has-badge-info has-badge-rounded has-badge-medium"
                        :class="{ 'has-new-content': whatsAppUnreadCount > 0 }"
                        :data-badge="whatsAppTotalCount" />
                    </span>
                  </a>
                </li>
                <li :class="{'is-active' : activeTab == 'Email', 'tab-disabled': activeTab !== 'Email' && (editMaximize)}"
                  @click="setActiveTab('Email')">
                  <a>
                    <span>
                      <span class="has-badge-child-offset3">
                        <span class="icon">
                          <i class="mdi mdi-email mdi-20px"
                            aria-hidden="true" />
                        </span>
                        <span class="">Email</span>
                      </span>
                      <span v-show="emailTotalCount"
                        class="has-badge-info has-badge-rounded has-badge-medium"
                        :class="{ 'has-new-content': emailUnreadCount > 0 }"
                        :data-badge="emailTotalCount" />
                    </span>
                  </a>
                </li>
              </ul>
            </div>

            <div class="is-flex-grow-1 is-flex is-flex-direction-column ">
              <div v-if="isEmail"
                class="is-flex-grow-1 ">
                <quote-email v-if="isEmail && isEmailerActive"
                  :quote="entity"
                  :enable-send="true"
                  :enable-attach="true"
                  :reply-to-message-id="replyToMessageId"
                  :reply-to-email="replyToEmail"
                  :selected-attachment-email-id="selectedAttachmentEmailId"
                  :is-incoming="isIncoming"
                  :msg-details="msgDetails"
                  @sent="emailSent"
                  @resetEmail="resetEmail"
                  @close="closeAttachmentModel"
                  @toggleEditMaximize="toggleEditMaximize"
                  @emailDataChanged="updateEmailPreview" />

              </div>
              <div v-else
                class="is-flex-grow-1 is-flex is-flex-direction-column is-overflow-hidden">
                <div class="is-flex-grow-1 is-flex is-flex-direction-column is-overflow-y-auto">
                  <article class="box detail-page-tile">
                    <div class="field">
                      <label class="label">To</label>
                      <div class="control">
                        <phone-no-autocomplete v-model="msgDetails.mobile"
                          :quote-id="value.quoteId"
                          :disabled="$licenceExpired"
                          @select="onPhoneNoSelected" />
                      </div>
                    </div>

                    <div class="field">
                      <div class="is-flex is-align-items-end">
                        <div class="is-flex-grow-1 mr-3">
                          <label class="label">Template</label>
                          <div class="control is-expanded">
                            <multiselect v-model="selectedTemplate"
                              track-by="message"
                              label="message"
                              placeholder="Select Template"
                              :options="templates"
                              :loading="isTemplateLoading"
                              :searchable="true"
                              :allow-empty="true"
                              :options-limit="templateFilter.pageSize"
                              :disabled="$licenceExpired"
                              @select="selectTemplate">
                              <template v-slot:singleLabel="{ option }">
                                <span>{{ truncateTemplateLabel(option && option.message) }}</span>
                              </template>
                              <template v-slot:option="{ option }">
                                <span>{{ truncateTemplateLabel(option && option.message) }}</span>
                              </template>
                            </multiselect>
                          </div>
                        </div>
                        <button class="button is-primary tooltip"
                          :data-tooltip="$licenceExpired ? 'Disabled, as your licence has expired' : 'Edit message template'"
                          :disabled="$licenceExpired"
                          @click="isSmsTemplateModalActive = true">
                          <span class="icon">
                            <i class="mdi mdi-pencil mdi-20px" />
                          </span>
                          <span>Edit</span>
                        </button>
                      </div>
                    </div>
                    <div v-if="approvedTemplate"
                      class="field">
                      <div class="control">
                        <span class="is-size-7 help has-text-grey-light">Approved Template</span>
                        <div class="box">
                          {{ approvedTemplate }}
                        </div>
                      </div>
                    </div>
                    <div class="field">
                      <div class="control">
                        <label class="label">Message</label>
                        <textarea v-model="msgDetails.message"
                          class="textarea"
                          :disabled="$licenceExpired"
                          rows="8"
                          :maxlength="maxLength"
                          placeholder="Text message" />
                      </div>
                      <span class="help"
                        :class="{'has-text-danger': msgDetails.message.length > maxLength * 0.9, 'has-text-warning': msgDetails.message.length > maxLength * 0.7}">
                        {{ msgDetails.message.length }}/{{ maxLength }}
                      </span>
                    </div>
                    <div class="is-flex is-justify-content-flex-end">
                      <button class="button is-success tooltip is-tooltip-left"
                        @click="send()"
                        @sent="emailSent"
                        :data-tooltip="getToolTip()"
                        :disabled="isDisabledSend || $licenceExpired">
                        <span class="icon">
                          <i class="mdi mdi-message-text mdi-20px" />
                        </span>
                        <span>Send</span>
                      </button>
                    </div>
                  </article>

                </div>
              </div>
            </div>
          </article>
        </div>
      </div>

      <div class="cell"
        :class="{'is-col-span-6': isEmail && !editMaximize, 'is-col-span-5': !isEmail && !editMaximize}"
        v-if="!editMaximize">
        <article class="box detail-page-tile is-flex-grow-1 is-flex is-flex-direction-column"
          style="height: calc(100vh - 8rem);">

          <p class="title">
            <span v-if="isEmail">
              Email Log
            </span>
            <span v-else-if="isWhatsApp">
              WhatsApp Log
            </span>
            <span v-else>
              SMS Log
            </span>
          </p>

          <div class="message-preview is-background-white pl-2 is-flex-grow-1 is-flex is-flex-direction-column is-overflow-hidden">
            <div v-if="isMessagesLoading"
              class="has-text-centered p-4">
              <span class="icon is-large">
                <i class="mdi mdi-loading mdi-spin mdi-24px" />
              </span>
              <p class="mt-2">Loading messages...</p>
            </div>
            <div v-else
              ref="messageContainer"
              class="is-overflow-y-auto py-2 is-flex-grow-1"
              style="scroll-behavior: smooth;">
              <div class="pr-3">
                <div v-for="(message) in messages"
                  :key="message.id"
                  class="is-flex mb-4 is-full-width"
                  :class="{
                    'is-justify-content-flex-start': message.isIncoming,
                    'is-justify-content-flex-end': message.isOutgoing
                  }">

                  <div class="message-wrapper"
                    :style="isEmail ? (message.isIncoming ? 'width: 90%; margin-right: 10%;' : 'width: 90%; margin-left: 10%;') : 'min-width: 50%; max-width: 85%; width: auto;'">
                    <div class="is-flex is-justify-content-space-between is-align-items-center mb-1 px-1">
                      <div class="is-size-7 has-text-weight-semibold has-text-grey">
                        <span v-if="isEmail">
                          <span v-if="message.isIncoming">
                            {{ message.sender || 'Unknown' }}
                          </span>
                          <span v-else>
                            {{ message.recipients }}
                          </span>
                        </span>
                        <span v-else>
                          <span v-if="message.isIncoming">
                            {{ message.sender ? formatPhoneNumber(message.sender) : 'Unknown' }}
                          </span>
                          <span v-else>
                            {{ message.recipients ? formatPhoneNumber(message.recipients) : 'Unknown' }}
                          </span>
                        </span>
                      </div>
                      <div class="is-size-7 has-text-grey is-flex is-align-items-center"
                        style="gap: 2px;">
                        <template v-if="isEmail">
                          <span class="material-symbols-rounded ls-size-7 has-text-weight-semibold"
                            :style="getEmailStatusIconStyle(message)">{{ getEmailStatusIconName(message) }}</span>
                          <span class="is-italic mr-1">{{ getEmailStatusLabel(message) }}</span>
                        </template>
                        <span class="is-italic">{{ $filters.formatDateTimeLocale(message.createdDate, $userInfo.locale) }}</span>
                      </div>
                    </div>

                    <div class="message-bubble has-background-white p-4 mb-2 is-shadowless has-border has-radius-normal is-relative"
                      :class="[getMessageBubbleClass(message), {'unread-animation': !message.isRead}]">

                      <div class="is-flex is-align-items-center is-absolute"
                        style="top: 8px; right: 8px; gap: 2px; opacity: 0.7;">
                        <span v-if="isEmail && message.isOutgoing"
                          class="icon tooltip is-tooltip-right is-tooltip-multiline mr-1"
                          :class="{'is-clickable': hasFailureDetail(message), 'is-tooltip-danger': emailStatus(message) === 'failed'}"
                          :data-tooltip="getEmailStatus(message)"
                          @click="openMessageModal(message)">
                          <i class="mdi mdi-16px"
                            :class="getEmailStatusIndicator(message)" />
                        </span>
                        <span v-if="isEmail"
                          class="icon tooltip is-tooltip-right is-clickable mr-1"
                          data-tooltip="View Email"
                          @click="viewEmail(message)">
                          <i class="mdi mdi-16px mdi-email-open" />
                        </span>
                        <span v-if="isEmail"
                          v-show="message.attachments"
                          class="icon tooltip is-tooltip-right is-clickable mr-1"
                          data-tooltip="Attachment"
                          @click="openAttachmentModel(message.id, message.isIncoming)">
                          <i class="mdi mdi-16px mdi-attachment" />
                        </span>
                        <span v-if="isEmail"
                          class="icon tooltip is-tooltip-right is-clickable"
                          data-tooltip="Reply"
                          @click="replyTo(message)">
                          <i class="mdi mdi-16px"
                            :class="[{'mdi-reply-outline': !isSelectedReplyToMessage(message.messageId)}, {'mdi-reply': isSelectedReplyToMessage(message.messageId)}]" />
                        </span>
                      </div>

                      <div class="content is-size-6 has-text-weight-normal">
                        <div v-if="isEmail && message.subject"
                          class="has-text-weight-semibold mb-1 is-size-7">
                          {{ message.subject }}
                        </div>
                        <div class="has-text-pre-wrap message-text-content">{{ truncate(message.message, 100) }}</div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Message Preview in Log -->
                <div v-if="!isMessagesLoading && (isEmail ? (msgDetails.message.trim() || msgDetails.emailSubject.trim() || msgDetails.emailTo.trim()) : (msgDetails.message.trim() || msgDetails.mobile))"
                  class="is-flex mb-4 is-full-width"
                  :class="{'is-justify-content-flex-end': true}"
                  style="opacity: 0.6;">
                  <div class="message-wrapper"
                    :style="isEmail ? 'width: 90%; margin-left: 10%;' : 'min-width: 50%; max-width: 85%; width: auto;'">
                    <div class="is-flex is-justify-content-space-between is-align-items-center mb-1 px-1">
                      <div class="is-size-7 has-text-weight-semibold has-text-grey">
                        <span v-if="isEmail">
                          You → {{ msgDetails.emailTo || 'No recipient' }}
                        </span>
                        <span v-else>
                          {{ formatPhoneNumber(msgDetails.mobile) }}
                        </span>
                      </div>
                      <div class="is-size-7 has-text-grey is-flex is-align-items-center"
                        style="gap: 2px;">
                        <span v-if="isEmail"
                          class="material-symbols-rounded ls-size-7 has-text-weight-semibold"
                          style="color: #98A6B3; font-variation-settings: 'FILL' 1, 'wght' 600, 'GRAD' 0, 'opsz' 20; font-style: normal;">drafts</span>
                        <span class="is-italic">Draft</span>
                      </div>
                    </div>

                    <div class="message-bubble p-4 mb-2 is-shadowless has-border has-radius-normal is-relative preview-bubble"
                      :class="[{'email-bubble': isEmail},getPreviewLogBubbleClass()]">

                      <div class="content is-size-6 has-text-weight-normal">
                        <!-- Email Preview Structure -->
                        <div v-if="isEmail">
                          <div v-if="!msgDetails.emailSubject.trim() && !msgDetails.emailTo.trim() && !msgDetails.message.trim()"
                            class="has-text-centered p-2">
                            <div class="is-flex is-justify-content-center is-align-items-center mb-2"
                              style="gap: 4px;">
                              <span class="has-background-grey is-inline-block"
                                style="width: 6px; height: 6px; border-radius: 50%; animation: typing-bounce 1.4s infinite ease-in-out; animation-delay: -0.32s;" />
                              <span class="has-background-grey is-inline-block"
                                style="width: 6px; height: 6px; border-radius: 50%; animation: typing-bounce 1.4s infinite ease-in-out; animation-delay: -0.16s;" />
                              <span class="has-background-grey is-inline-block"
                                style="width: 6px; height: 6px; border-radius: 50%; animation: typing-bounce 1.4s infinite ease-in-out;" />
                            </div>
                            <span class="is-size-7 is-italic">Start composing email to show preview...</span>
                          </div>
                          <div v-else>
                            <!-- Email Header Preview -->
                            <div class="email-header-preview mb-3">
                              <div v-if="msgDetails.emailTo.trim()"
                                class="mb-1">
                                <span class="has-text-weight-semibold is-size-7">To:</span>
                                <span class="is-size-7 ml-1">{{ msgDetails.emailTo }}</span>
                              </div>
                              <div v-if="msgDetails.emailCc.trim()"
                                class="mb-1">
                                <span class="has-text-weight-semibold is-size-7">Cc:</span>
                                <span class="is-size-7 ml-1">{{ msgDetails.emailCc }}</span>
                              </div>
                              <div v-if="msgDetails.emailBcc.trim()"
                                class="mb-1">
                                <span class="has-text-weight-semibold is-size-7 ">Bcc:</span>
                                <span class="is-size-7 ml-1">{{ msgDetails.emailBcc }}</span>
                              </div>
                              <div v-if="msgDetails.emailSubject.trim()"
                                class="mb-2">
                                <span class="has-text-weight-semibold is-size-7">Subject:</span>
                                <span class="is-size-7 ml-1 has-text-weight-semibold">{{ msgDetails.emailSubject }}</span>
                              </div>
                            </div>
                            <hr v-if="msgDetails.emailTo.trim() || msgDetails.emailSubject.trim()"
                              class="my-2 has-background-grey-light"
                              style="height: 1px; max-width: 100%; overflow: hidden; margin-left: 0; margin-right: 0;">
                            <!-- Email Body Preview -->
                            <div v-if="msgDetails.message.trim()"
                              class="is-italic has-text-pre-wrap message-text-content"
                              style="opacity: 0.8;">
                              {{ getProcessedMessage() }}
                            </div>
                            <div v-else-if="msgDetails.emailTo.trim() || msgDetails.emailSubject.trim()"
                              class="has-text-centered p-2">
                              <span class="is-size-7 is-italic">Email body is empty...</span>
                            </div>
                          </div>
                        </div>
                        <!-- SMS/WhatsApp Preview Structure -->
                        <div v-else>
                          <div v-if="!msgDetails.message.trim()"
                            class="has-text-centered p-2">
                            <div class="is-flex is-justify-content-center is-align-items-center mb-2"
                              style="gap: 4px;">
                              <span class="has-background-grey is-inline-block"
                                style="width: 6px; height: 6px; border-radius: 50%; animation: typing-bounce 1.4s infinite ease-in-out; animation-delay: -0.32s;" />
                              <span class="has-background-grey is-inline-block"
                                style="width: 6px; height: 6px; border-radius: 50%; animation: typing-bounce 1.4s infinite ease-in-out; animation-delay: -0.16s;" />
                              <span class="has-background-grey is-inline-block"
                                style="width: 6px; height: 6px; border-radius: 50%; animation: typing-bounce 1.4s infinite ease-in-out;" />
                            </div>
                            <span class="is-size-7 is-italic">Start typing to show preview...</span>
                          </div>
                          <div v-else
                            class="is-italic has-text-pre-wrap message-text-content"
                            style="opacity: 0.8;">
                            {{ getProcessedMessage() }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <quote-email-viewer-modal :active.sync="isViewEmail"
            :show-icon="true"
            :email="viewMessage"
            @cancel="closeViewEmail"
            @close="closeViewEmail">
            <p slot="text-title">Email</p>
          </quote-email-viewer-modal>
        </article>
      </div>

      <sms-template-modal v-if="isSmsTemplateModalActive"
        :active.sync="isSmsTemplateModalActive"
        @close="closeSmsTemplateModal" />

      <base-modal-ex :active.sync="isMessageModalActive"
        :animation-in="animationIn"
        :animation-out="animationOut"
        :animation-duration="animationDuration"
        :can-cancel="false"
        :min-width="60"
        has-modal-card>
        <header class="modal-card-head">
          <p class="modal-card-title"
            :class="{ 'is-flex-items-center' : true}">
            <span>Email Delivery Failed Message</span>
          </p>
        </header>
        <section class="modal-card-body p-0 m-0"
          style="position:relative;">
          <div class="columns p-0 m-0">
            <div class="column p-0 m-0">
              <div class="box p-0 m-0">
                <div class="columns is-multiline p-0 m-0">
                  <div class="column is-full p-3 m-0">
                    <div v-html="messageModalMessage" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <footer class="modal-card-foot">
          <div :style="`width: 100%; display: flex; justify-content: space-between;`">
            <div style="align-self: flex-start;" />
            <div style="align-self: flex-end;">
              <button class="button tooltip"
                @click="closeMessageModal()"
                data-tooltip="Close">
                <span class="icon">
                  <i class="mdi mdi-close mdi-18px" />
                </span>
                <span>Close</span>
              </button>
            </div>
          </div>
        </footer>
      </base-modal-ex>
    </div>
  </div>
</template>

<script>
import { SmsSendMessageModel } from '@/classes/viewmodels'
import Multiselect from 'vue-multiselect'
import { FocusInserted } from '@/components/directives'
import { SmsService, WhatsAppService, EmailService } from '@/services'
import { PhoneTypes, CommunicationTypes, NotificationType, EventHubTypes } from '@/enums'
import SmsTemplateModal from '@/components/Sms/SmsTemplateModal'
import { roundAwayFromZero } from '@/components/utils/AccountingFunctions'
import { truncate } from '@/utils/StringFunctions'

// import { VueEmail } from '@/components/VueEmail'
// import mimeTypes from 'mime-types'
// import { Emailer } from '@/classes'
// import StoreUtil from '@/store/utils'
import _cloneDeep from 'lodash/cloneDeep'
import QuoteCommunicationsMixin from './mixins/QuoteCommunicationsMixin'
import { createNamespacedHelpers } from 'vuex'

const { mapGetters, mapActions } = createNamespacedHelpers('quoteContentCounts')
// import { QuoteImage } from '../components/QuoteImage'
import QuoteEmail from './components/QuoteEmail.vue'
import QuoteEmailViewerModal from './components/QuoteEmailViewerModal.vue'
import { BaseModalEx } from '@/components/BulmaModal'
import PhoneNoAutocomplete from './components/QuoteHeader/PhoneNoAutocomplete.vue'

// Temporary const for copyright message
// const divider = '=============================================================='
// const copyright =
//   'All accompanying materials are the exclusive property of [COMPANY].  All [COMPANY] rights are reserved.  These Materials must not be reproduced, adapted, modified, published, or communicated to any person in any form, without express prior written consent of [COMPANY].  Any unauthorised use of these Materials will be vigorously pursued and may result in legal action, including a claim for damages or an account for loss of profits.'

export default {
  name: 'QuoteCommunications',
  // components: { Multiselect, SmsTemplateModal, VueEmail, QuoteEmail },
  components: { Multiselect, SmsTemplateModal, QuoteEmailViewerModal, QuoteEmail, BaseModalEx, PhoneNoAutocomplete }, //QuoteEmailViewerModal,
  directives: {
    FocusInserted
  },
  mixins: [QuoteCommunicationsMixin],
  props: {
    value: {
      type: Object,
      default: null
    },
    customer: {
      type: Object,
      default: null
    },
    vehicle: {
      type: Object,
      default: null
    },
    animationIn: {
      type: String,
      default: 'zoomIn'
    },
    animationOut: {
      type: String,
      default: 'zoomOut'
    },
    animationDuration: {
      type: [String, Number],
      default: 0.3
    }
  },
  data: () => {
    return {
      entity: null,
      phoneNoMask: Array(31).join('P'),
      phoneNoTokens: {
        P: {
          pattern: /[0-9 ()\-+]/
        }
      },
      msgDetails: {
        quoteId: null,
        customer: null,
        rego: null,
        jobStart: null,
        jobEnd: null,
        excess: null,
        mobile: null,
        message: '',
        shopName: '',
        imgLink: '',
        // Email specific fields
        emailTo: '',
        emailSubject: '',
        emailCc: '',
        emailBcc: ''
      },
      smsDetails: new SmsSendMessageModel(),
      isTemplateLoading: false,
      isMessagesLoading: false,
      templates: [],
      messages: [],
      selectedTemplate: '',
      templateFilter: {
        message: '',
        pageIndex: 1,
        pageSize: 999
      },
      isSmsTemplateModalActive: false,
      interval: null,
      markAsReadTimer: null,
      activeTab: CommunicationTypes.SMS,
      maxLength: 0,
      isShowWhatsApp: false,
      approvedTemplate: '',
      replyToMessageId: '',
      replyToSender: '',
      replyToContent: '',
      replyToEmail: {},
      selectedAttachmentEmailId: '',
      isIncoming: null,
      editMaximize: false,
      isViewEmail: false,
      viewMessage: {},
      isMessageModalActive: false,
      messageModalMessage: '',
      isEmailerActive: true,
      // isEmailModalActive: false,
      // isImageAttachActive: false,
      // emailer: {
      //   reportName: null
      // },
      // reportBytes: null,
      // reportContentType: '',
      // selectedImages: [],
      // quoteIds: []
      selectedPhone: null,
      groupedOptions: [],
      loading: false
    }
  },
  computed: {
    // Shared with the task bar: one poll for the whole quote, not one per view.
    ...mapGetters(['smsUnreadCount', 'whatsAppUnreadCount', 'emailUnreadCount', 'smsTotalCount', 'whatsAppTotalCount', 'emailTotalCount']),
    isDisabledSend() {
      var disabled =
        !this.msgDetails.message || !this.msgDetails.mobile || this.isEmptyString(this.msgDetails.mobile) || !this.validateNumber(this.msgDetails.mobile)
      return disabled
    },
    communicationTypes: function () {
      return CommunicationTypes
    },
    isSMS: function () {
      return this.activeTab == CommunicationTypes.SMS
    },
    isWhatsApp: function () {
      return this.activeTab == CommunicationTypes.WhatsApp
    },
    isEmail: function () {
      return this.activeTab == CommunicationTypes.Email
    }

    //reportExtension() {
    //  return mimeTypes.extension(this.reportContentType)
    //}
  },
  watch: {
    isEmail(value) {
      //this.isEmailModalActive = value
      if (!value) {
        this.replyToMessageId = ''
      }
    },
    'msgDetails.message'(newValue, oldValue) {
      // Scroll to bottom when user starts typing (only if content is being added)
      if (newValue && newValue.length > (oldValue || '').length) {
        this.scrollToBottom()
      }
    },
    // Watch id (not the object) so autosave reassigning customer doesn't clobber autocomplete edits.
    'customer.id': {
      handler() {
        if (!this.customer || !this.customer.phones) return
        const mobile = this.customer.phones.find((p) => p.type === PhoneTypes.Mobile.toString())
        this.msgDetails.mobile = mobile ? mobile.no : ''
      },
      immediate: true
    }
  },
  async created() {
    this.getEntity()
    this.setParams()
    await this.getSettings()
    this.getSmsMessageDropdown()
    this.autoRefresh()
    this.getMessages()
    this.getMaxLength()
    //this.clearSessionStorage()
    this.assignMessageDetails(this.msgDetails)
  },
  mounted() {
    // Scroll message log to bottom on mount
    this.$nextTick(() => {
      this.scrollToBottom(true) // Force scroll on initial mount
    })
  },
  updated() {
    const unreadCount = this.messages.reduce((acc, cur) => (!cur.isRead ? ++acc : acc), 0)
    if (unreadCount) {
      this.scrollToBottom(true) // Force scroll when there are unread messages
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
    // Otherwise a pending timer fires after the user has navigated away, marking messages
    // read that were never on screen and emitting into a torn-down component.
    this.clearMarkAsReadTimer()
  },
  methods: {
    ...mapActions({ refreshContentCounts: 'refresh', markContentRead: 'markRead' }),
    validateNumber(phoneNo) {
      const regex = /^[0-9]*$/
      phoneNo = phoneNo.replace(/\s+/g, '')
      return regex.test(phoneNo)
    },
    onPhoneNoSelected(option) {
      if (!option || option.isGroupHeader) {
        return
      } else {
        this.msgDetails.mobile = String(option.phoneNo || '').replace(/\s+/g, '')
      }
      // Handle selection
    },
    async getEntity() {
      if (!this.currentSnapshot) {
        await this.getStoreItem(this.$route.params.quoteId)
      }
      this.entity = _cloneDeep(this.currentSnapshot)
    },
    async getMessages() {
      this.isMessagesLoading = true
      try {
        if (this.isSMS) {
          this.messages = await SmsService.getMessages(this.value.quoteId)
        } else if (this.isWhatsApp) {
          this.messages = await WhatsAppService.getMessages(this.value.quoteId)
        } else if (this.isEmail) {
          this.messages = await EmailService.getMessages(this.value.quoteId)
          //console.log(this.messages)
        }
        this.setMessagesAsRead()
      } finally {
        this.isMessagesLoading = false
        // Scroll to bottom after messages are loaded
        this.$nextTick(() => {
          this.scrollToBottom(true) // Force scroll for data loading
        })
      }
    },
    assignMessageDetails(message) {
      const jobStart = this.value.jobStart ? new Date(this.value.jobStart).toLocaleDateString(this.$userInfo.locale) : 'DD/MM/YYYY'
      const jobEnd = this.value.jobEnd ? new Date(this.value.jobEnd).toLocaleDateString(this.$userInfo.locale) : 'DD/MM/YYYY'

      message.quoteId = this.value.quoteId
      message.customer = this.customer.firstname ? this.customer.firstname : this.customer.fullname
      message.rego = this.vehicle.rego
      message.jobStart = jobStart
      message.jobEnd = jobEnd
      message.excess = this.value.excessWithGst ? this.value.excess + roundAwayFromZero((this.value.excess * this.value.gstRate) / 100) : this.value.excess
      message.shopName = this.$userInfo.companyName
    },
    async send() {
      this.$showSpinner('Sending...')
      this.assignMessageDetails(this.msgDetails)
      var type = this.activeTab
      try {
        if (this.isSMS) {
          await SmsService.sendSms(this.msgDetails)
        } else if (this.isWhatsApp) {
          await WhatsAppService.sendWhatsApp(this.msgDetails)
        }
        this.$notification.openNotificationWithType('success', `Send ${type}`, 'Message Sent')
        //if (this.isSMS) this.smsDetails.message = ''
        this.msgDetails.message = ''
        this.selectedTemplate = ''
      } catch (e) {
        this.$notification.openMessageXhrError(`Send ${type}`, e)
      } finally {
        await this.getMessages()
        await this.refreshContentCounts()
        this.$hideSpinner()
      }
    },
    async getSmsMessageDropdown() {
      this.isTemplateLoading = true
      this.templates = await SmsService.getSmsMessageDropdownProto(this.templateFilter)
      if (this.templateFilter.message !== '') {
        this.selectedTemplate = this.templates.find((c) => c.message === this.templateFilter.message)
      }
      this.isTemplateLoading = false
    },
    selectTemplate(selected) {
      this.templateFilter.message = selected.message
      this.msgDetails.message = selected.message //this.smsDetails.message = selected.message
    },
    async closeSmsTemplateModal() {
      this.isSmsTemplateModalActive = false
      this.resetTemplateFilter()
      await this.getSmsMessageDropdown()
    },
    autoRefresh() {
      // Only the message list. The sub-tab counts come from the quoteContentCounts
      // store, which the task bar polls once for the whole quote.
      this.interval = setInterval(async () => {
        await this.getMessages()
      }, 30000)
    },
    stopAutoRefresh() {
      clearInterval(this.interval)
    },
    setMessagesAsRead() {
      // Only ever one pending timer. getMessages() runs on every tab switch, so without
      // this a few quick switches would leave several overlapping timers running.
      this.clearMarkAsReadTimer()

      const unread = this.messages.filter((m) => !m.isRead)
      if (!unread || unread.length === 0) return

      // Captured now rather than read inside the callback: the user can switch tab during
      // the ten seconds, and `this.activeTab` would then name the channel they moved to,
      // marking that one read instead of the one they were actually looking at.
      const channel = this.activeTab

      this.markAsReadTimer = setTimeout(async () => {
        this.markAsReadTimer = null
        try {
          if (channel === CommunicationTypes.SMS) {
            await SmsService.setMessagesAsRead(this.value.quoteId)
            this.markContentRead('sms')
          } else if (channel === CommunicationTypes.WhatsApp) {
            await WhatsAppService.setMessagesAsRead(this.value.quoteId)
            this.markContentRead('whatsApp')
          } else if (channel === CommunicationTypes.Email) {
            await EmailService.setMessagesAsRead(this.value.quoteId)
            this.markContentRead('email')
          }
        } catch (e) {
          // The 30s refresh re-reads the true counts, so a failure here self-corrects.
          console.error(e)
          return
        }

        // Only the messages still on screen for that channel - if the user has since
        // switched tab, this.messages belongs to a different channel.
        if (this.activeTab === channel) {
          this.messages.forEach((m) => (m.isRead = true))
        }

        // The store already knows, from markContentRead above. This is for anything
        // else listening - the counts are held per channel, so the event names which
        // one was cleared rather than reporting the tab as read.
        this.$eventHub.$emit(EventHubTypes.CommsRead, channel)
      }, 10000)
    },
    clearMarkAsReadTimer() {
      if (this.markAsReadTimer) {
        clearTimeout(this.markAsReadTimer)
        this.markAsReadTimer = null
      }
    },
    async setActiveTab(tab) {
      this.activeTab = tab
      await this.getMessages()
      this.getMaxLength()
      this.resetMsgLength()

      // Clear email-specific fields when switching away from email
      if (tab !== CommunicationTypes.Email) {
        this.msgDetails.emailTo = ''
        this.msgDetails.emailCc = ''
        this.msgDetails.emailBcc = ''
        this.msgDetails.emailSubject = ''
        this.msgDetails.message = '' // Clear message content when switching away from email
      }

      // Scroll to bottom after tab switch and messages load
      this.$nextTick(() => {
        this.scrollToBottom(true) // Force scroll for tab switching
      })
    },
    getToolTip() {
      if (this.$licenceExpired) {
        return 'Disabled, as your licence has expired'
      }
      return `Send ${this.activeTab}`
    },
    getMaxLength() {
      this.maxLength =
        this.activeTab == CommunicationTypes.SMS
          ? 2000
          : this.activeTab == CommunicationTypes.WhatsApp
          ? 2000
          : this.activeTab == CommunicationTypes.Email
          ? 2000
          : 0
    },
    resetMsgLength() {
      this.msgDetails.message = this.msgDetails.message.slice(0, this.maxLength)
    },
    setParams() {
      var type = this.$route.params.type
      if (type) {
        if (type == NotificationType.QuoteSmsIncoming) this.activeTab = CommunicationTypes.SMS
        else if (type == NotificationType.QuoteWhatsAppIncoming) this.activeTab = CommunicationTypes.WhatsApp
        else if (type == NotificationType.QuoteEmailIncoming) this.activeTab = CommunicationTypes.Email
      }
    },
    async getSettings() {
      var setting = await WhatsAppService.getCompanyExternalSetting()
      if (setting) {
        this.isShowWhatsApp = setting.active == '1'
        this.approvedTemplate = setting.approvedTemplate
      }
    },
    truncate(str, max) {
      return this.isEmail ? truncate(str, max) : str
    },
    replyTo(message) {
      // .messageId, message.isIncoming ? message.sender : message.recipients, message.message
      const isCancelReply = this.replyToMessageId === message.messageId
      this.replyToMessageId = isCancelReply ? '' : message.messageId
      // this.replyToSender = isCancelReply ? '' : message.isIncoming ? message.sender : message.recipients
      this.replyToEmail = isCancelReply ? {} : message
      // this.replyToContent = isCancelReply ? '' : message
    },
    sent() {},
    isSelectedReplyToMessage(messageId) {
      if (!this.replyToMessageId) return false
      return this.replyToMessageId === messageId
    },
    messageBodyStyle(message) {
      if (this.isSelectedReplyToMessage(message.messageId)) return 'is-warning'
      else if (message.isOutgoing) return 'is-info'
      else if (message.isIncoming) return 'is-success'
      else return ''
    },
    openAttachmentModel(messageId, isIncoming) {
      this.selectedAttachmentEmailId = messageId
      this.isIncoming = isIncoming
    },
    closeAttachmentModel() {
      this.selectedAttachmentEmailId = ''
      this.isIncoming = null
    },
    toggleEditMaximize() {
      this.editMaximize = !this.editMaximize
    },
    updateAttachment() {
      this.$emit('image-uploaded')
    },
    viewEmail(message) {
      this.viewMessage = message
      this.isViewEmail = !this.isViewEmail
      //console.log(this.isViewEmail)
    },
    closeViewEmail() {
      this.viewMessage = {}
      this.isViewEmail = !this.isViewEmail
      this.resetTemplateFilter()
      this.getSmsMessageDropdown()
      //console.log(this.isViewEmail)
    },
    // Single source of truth for an outgoing email's status. Every status getter
    // below derives from this one so they cannot disagree with each other.
    //
    // A single EmailOutgoing row can legitimately carry BOTH deliveredAt and
    // failedAt: Mailgun raises an event per recipient against the one row, and a
    // temporary failure can later be retried into a success. The later of the two
    // events is therefore the current truth. Equal timestamps resolve to 'failed'
    // (Mailgun timestamps are second-resolution, so surface the problem).
    emailStatus(message) {
      const delivered = message.deliveredAt ? new Date(message.deliveredAt).getTime() : null
      const failed = message.failedAt ? new Date(message.failedAt).getTime() : null
      if (delivered && failed) return failed >= delivered ? 'failed' : 'delivered'
      if (failed) return 'failed'
      if (delivered) return 'delivered'
      return 'sent'
    },
    // A failure the user may want to read, even where a later retry delivered it.
    // Guards the reason modal: the webhook sets FailedOn before it resolves the
    // failure text, so failedMessage can be null while failedAt is set.
    hasFailureDetail(message) {
      return !!message.failedAt && !!message.failedMessage
    },
    getEmailStatusIndicator(message) {
      switch (this.emailStatus(message)) {
        case 'failed': return 'mdi-alert-circle has-text-danger'
        case 'delivered': return 'mdi-check-all'
        default: return 'mdi-check'
      }
    },
    getEmailStatus(message) {
      const at = value => this.$filters.formatDateTimeLocale(value, this.$userInfo.locale)
      const reason = message.failedMessage ? ' — ' + message.failedMessage : ''
      const status = this.emailStatus(message)
      if (status === 'failed') {
        return message.deliveredAt
          ? 'Delivered at ' + at(message.deliveredAt) + ', then failed at ' + at(message.failedAt) + reason
          : 'Failed at ' + at(message.failedAt) + reason
      }
      if (status === 'delivered') {
        return message.failedAt
          ? 'Failed at ' + at(message.failedAt) + reason + ', then delivered at ' + at(message.deliveredAt)
          : 'Delivered at ' + at(message.deliveredAt)
      }
      return 'Sent at ' + at(message.sentAt)
    },
    getEmailStatusIconName(message) {
      if (message.isIncoming) return 'mark_email_read'
      if (this.emailStatus(message) === 'failed') return 'warning'
      return 'send'
    },
    getEmailStatusLabel(message) {
      if (message.isIncoming) return 'Received'
      if (this.emailStatus(message) === 'failed') return 'Error in sending'
      return 'Sent'
    },
    getEmailStatusIconStyle(message) {
      const base = { fontVariationSettings: '\'FILL\' 1, \'wght\' 600, \'GRAD\' 0, \'opsz\' 20', fontStyle: 'normal' }
      if (message.isIncoming) return { ...base, color: '#4B9EF1' }
      if (this.emailStatus(message) === 'failed') return { ...base, color: '#E97C96' }
      return { ...base, color: '#7CE999' }
    },
    openMessageModal(message) {
      if (!this.hasFailureDetail(message)) return
      this.messageModalMessage = message.failedMessage.replace(/\\n/g, '<br/>')
      this.isMessageModalActive = true
    },
    closeMessageModal() {
      this.messageModalMessage = ''
      this.isMessageModalActive = false
    },
    resetEmail() {
      this.replyToMessageId = ''
      // this.replyToSender = ''
      this.replyToContent = ''
      this.replyToEmail = {}
      this.refreshEmailer = true

      // Clear email preview fields
      this.msgDetails.emailTo = ''
      this.msgDetails.emailCc = ''
      this.msgDetails.emailBcc = ''
      this.msgDetails.emailSubject = ''
      this.msgDetails.message = ''

      if (this.isEmailerActive === true) {
        this.isEmailerActive = false
        this.$nextTick(() => {
          this.isEmailerActive = true
        })
      }
    },
    async emailSent() {
      this.resetEmail()
      await this.getMessages()
      // Sending changes the totals, and the reply may clear unread state, so take a
      // fresh count now rather than leaving the badge stale until the next poll.
      await this.refreshContentCounts()
    },
    getCurrentTime() {
      const now = new Date()
      return now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
    },
    getPreviewBubbleClass() {
      if (this.isWhatsApp) return 'whatsapp-bubble'
      if (this.isEmail) return 'email-bubble'
      return 'sms-bubble'
    },
    getMessageBubbleClass(message) {
      const classes = []

      if (this.isSelectedReplyToMessage(message.messageId)) {
        classes.push('has-background-warning', 'has-text-white')
      } else if (message.isIncoming) {
        classes.push('has-background-success', 'has-text-white') // Green for incoming
      } else {
        classes.push('has-background-primary', 'has-text-white') // Blue for outgoing
      }

      if (this.isEmail) {
        classes.push('email-bubble')
      } else {
        if (message.isIncoming) {
          classes.push('has-radius-left')
        } else {
          classes.push('has-radius-right')
        }
      }

      return classes.join(' ')
    },
    formatPhoneNumber(phoneNumber) {
      if (!phoneNumber) return ''
      // Return phone number without hyphens - just clean digits or original format
      const cleaned = phoneNumber.replace(/\D/g, '')
      return cleaned || phoneNumber
    },
    getProcessedMessage() {
      if (!this.msgDetails.message) return ''

      // Build Message Text - replace placeholders with actual data
      let message = this.msgDetails.message

      // Replace placeholders with actual values
      message = message.replace(/\[NAME\]/g, this.msgDetails.customer || '')
      message = message.replace(/\[REGO\]/g, this.msgDetails.rego || '')
      message = message.replace(/\[EXCESS\]/g, this.msgDetails.excess ? '$' + Number(this.msgDetails.excess).toFixed(2) : '')
      message = message.replace(/\[EST START DATE\]/g, this.msgDetails.jobStart || '')
      message = message.replace(/\[EST END DATE\]/g, this.msgDetails.jobEnd || '')
      message = message.replace(/\[SHOPNAME\]/g, this.msgDetails.shopName || '')

      // Clean up HTML tags
      message = message.replace(/<p>/g, '')
      message = message.replace(/<\/p>/g, '')

      return message
    },
    getPreviewLogBubbleClass() {
      let classes = ['has-radius-right']
      // For SMS/WhatsApp previews, use grey background with dark text
      classes.push('has-background-grey-lighter', 'has-text-dark')

      return classes.join(' ')
    },
    scrollToBottom(force = false) {
      this.$nextTick(() => {
        if (this.$refs.messageContainer) {
          const container = this.$refs.messageContainer
          if (force) {
            // Force scroll to bottom (for initial load and tab switches)
            container.scrollTop = container.scrollHeight
          } else {
            // Only scroll if not already at the bottom (for typing events)
            const isAtBottom = container.scrollTop + container.clientHeight >= container.scrollHeight - 10
            if (!isAtBottom) {
              container.scrollTop = container.scrollHeight
            }
          }
        }
      })
    },
    updateEmailPreview(emailData) {
      // Update msgDetails with email information for preview
      if (emailData) {
        this.msgDetails.emailTo = emailData.toEmails ? emailData.toEmails.join(', ') : ''
        this.msgDetails.emailCc = emailData.ccEmails ? emailData.ccEmails.join(', ') : ''
        this.msgDetails.emailBcc = emailData.bccEmails ? emailData.bccEmails.join(', ') : ''
        this.msgDetails.emailSubject = emailData.subject || ''
        this.msgDetails.message = emailData.message || ''
      }
    },
    resetTemplateFilter() {
      this.templateFilter = {
        message: '',
        pageIndex: 1,
        pageSize: 999
      }
    },
    truncateTemplateLabel(str, max = 60) {
      return truncate(str, max)
    },
    isEmptyString(str) {
      return typeof str === 'string' && str.trim() === ''
    }
  },
  beforeRouteEnter(to, from, next) {
    next()
  },
  beforeRouteLeave(to, from, next) {
    next()
  },
  truncate(message, noOfChar) {
    return truncate(sender, noOfChar)
  }
}
</script>

<style lang="scss">
.quote-comms-licence-expired {
  .control:has(> input:disabled),
  .control:has(> textarea:disabled),
  .control:has(> .multiselect--disabled),
  .control:has(> .vue-input-tag-wrapper.read-only) {
    position: relative;
    cursor: not-allowed;

    &:hover::before {
      content: 'Disabled, as your licence has expired';
      position: absolute;
      top: 100%;
      left: 0;
      transform: translateY(0.5rem);
      z-index: 30;
      padding: 0.4rem 0.8rem;
      border-radius: 4px;
      background: rgba(74, 74, 74, 0.9);
      color: #fff;
      font-size: 0.75rem;
      font-weight: normal;
      white-space: nowrap;
      pointer-events: none;
    }
  }
}
</style>

<style lang="scss" scoped>
/* Essential animations and custom styles */
@keyframes typing-bounce {
  0%,
  80%,
  100% {
    transform: scale(0.8);
    opacity: 0.5;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes highlight-unread {
  0% {
    filter: brightness(0.4) contrast(0.4);
  }
  50% {
    filter: brightness(0.6) contrast(0.6);
  }
  100% {
    filter: brightness(1) contrast(1);
  }
}

.unread-animation {
  animation: highlight-unread 10s 1;
  font-weight: bold;
}

/* Custom radius classes */
.has-radius-left {
  border-radius: 4px 18px 18px 18px !important;
}

.has-radius-right {
  border-radius: 18px 18px 4px 18px !important;
}

.has-radius-normal {
  border-radius: 18px !important;
}

.has-text-pre-wrap {
  white-space: pre-wrap !important;
}

/* Icon color override */
i.icon-green {
  color: var(--bulma-success);
}

/* Message Preview Styles (still used in left preview section) */
.message-preview {
  border-radius: 12px;
  border: 1px solid var(--border-color);
}

.email-header-preview {
  border-bottom: 1px solid var(--bulma-border-strong) !important;
  padding-bottom: 8px;
  margin-bottom: 8px;
}

.email-header-preview .mb-1:last-child {
  margin-bottom: 0 !important;
}

.message-bubble:not(.email-bubble) {
  max-width: 300px;
  margin-bottom: 8px;
}

.message-bubble.whatsapp-bubble {
  background: var(--bulma-success-light);
  color: var(--bulma-text);
}

.message-bubble.email-bubble {
  width: 100%;
  border-radius: 8px;
}

/* Email preview content container */
.email-bubble .content {
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
  max-width: 100%;
  overflow: hidden;
}

.email-bubble hr {
  max-width: 100% !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
  overflow: hidden;
}

/* Message text content - handles long URLs and text wrapping */
.message-text-content {
  overflow-wrap: break-word !important;
  word-wrap: break-word !important;
  word-break: break-word !important;
  hyphens: auto;
  max-width: 100%;
  overflow: hidden;
}
</style>

